import React from 'react';
import { useLanguage } from '../context/LanguageContext';

export default function ProductCard({ product }) {
  const { t, lang } = useLanguage();
  const data = product[lang];

  return (
    <article className={`product-card ${product.featured ? 'product-card--featured' : ''}`}>
      <div className="product-card__head">
        <span className="product-card__code" dir="ltr">{product.code}</span>
        {product.featured && <span className="product-card__badge">{t.products.featuredBadge}</span>}
      </div>
      <h3 className="product-card__title">{data.title}</h3>
      <p className="product-card__desc">{data.desc}</p>

      {data.applications && data.applications.length > 0 && (
        <div className="product-card__block">
          <span className="product-card__label">{t.products.applicationsLabel}</span>
          <ul className="product-card__tags">
            {data.applications.map((app) => (
              <li key={app}>{app}</li>
            ))}
          </ul>
        </div>
      )}

      {data.features && data.features.length > 0 && (
        <div className="product-card__block">
          <span className="product-card__label">{t.products.featuresLabel}</span>
          <ul className="product-card__features">
            {data.features.map((f) => (
              <li key={f}>{f}</li>
            ))}
          </ul>
        </div>
      )}
    </article>
  );
}
